import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Roles } from "../../utils/role";
import { api } from "../../services/api";

export interface UserState {
  _id?: string;
  zohoCustomerId: string;
  firstName: string;
  lastName: string;
  steps?: string | number;
  role: string;
  solarStudyInvite?: boolean;
  contactOwnerUserId: string;
  Contact_Group?: string | null;
  email?: string | null;
  purlDocuments?: boolean;
  //Need to remove this code after client a/b testing is complete
  assignedOnboardingFlow?: "A" | "B";
  //End a/b testing code
}

const initialState: UserState = {
  _id: "",
  zohoCustomerId: "",
  firstName: "",
  lastName: "",
  steps: "",
  role: Roles.CUSTOMER,
  solarStudyInvite: false,
  contactOwnerUserId: "",
  Contact_Group: "",
  email: "",
  purlDocuments: false
};

export const loginSlice = createSlice({
  name: "userLogin",
  initialState,
  reducers: {
    setUserLogin: (state, action: PayloadAction<UserState>) => {
      state._id = action.payload._id || "";
      state.zohoCustomerId = action.payload.zohoCustomerId || "";
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.steps = action.payload.steps || "";
      state.role = action.payload.role || "";
      state.solarStudyInvite = action.payload.solarStudyInvite || false;
      state.contactOwnerUserId = action.payload.contactOwnerUserId || "";
      state.Contact_Group = action.payload.Contact_Group || "";
      state.email = action.payload.email || "";
      state.purlDocuments = action.payload.purlDocuments || false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.getMe.matchFulfilled, (state, { payload }) => {
      const { user, role } = payload.data;
      state._id = user._id || "";
      state.zohoCustomerId = user.zohoCustomerId || "";
      state.firstName = user.firstName;
      state.lastName = user.lastName;
      state.steps = user.steps || "";
      state.role = role || Roles.CUSTOMER;
      state.solarStudyInvite = user.solarStudyInvite || false;
      state.contactOwnerUserId = "";
      state.Contact_Group = user.contactGroupType || "";
      state.email = user.email || "";
      state.purlDocuments = user.purlDocuments || false;
      //Need to remove this code after client a/b testing is complete
      state.assignedOnboardingFlow = payload.data.currentOnboardingFlow;
      //End a/b testing code
    });
  },
});

export const { setUserLogin } = loginSlice.actions;

export default loginSlice.reducer;
